import { DateTime } from 'luxon';

type ReportDates = {
  from?: string;
  to?: string;
  dateFrom?: string;
  dateTo?: string;
  fromDate?: string;
  toDate?: string;
};

type DateRangeValidator = (
  _value: string,
  allValues: { report?: ReportDates },
) => string | undefined;

const DATE_RANGES: [keyof ReportDates, keyof ReportDates][] = [
  ['from', 'to'],
  ['dateFrom', 'dateTo'],
  ['fromDate', 'toDate'],
];

const validateDateRanges = (allowEqualDates: boolean): DateRangeValidator => (
  (_value, allValues) => {
    const report = allValues.report ?? {};
    const isInvalid = DATE_RANGES.some(([fromKey, toKey]) => {
      const from = report[fromKey];
      const to = report[toKey];
      if (!from || !to) return false;
      const start = DateTime.fromISO(from);
      const end = DateTime.fromISO(to);
      return allowEqualDates ? start > end : start >= end;
    });
    return isInvalid ? 'from date should be before to date' : undefined;
  }
);

export const strictDateRangeValidation = validateDateRanges(false);

const dateRangeValidation = validateDateRanges(true);

export default dateRangeValidation;
